{
    const windowHeight = useInnerHeight();

    document.querySelectorAll<HTMLElement>('.module-title').forEach(element => onScroll(() => {
        const { top, height } = element.getBoundingClientRect();
        const posY = top + (height / 2);
        const viewportY = posY / windowHeight();
        element.style.setProperty('--viewport-y', `${Math.min(1, Math.max(0, viewportY))}`);
    }));

    function useInnerHeight() {
        let innerHeight = window.innerHeight;
        return () => (Math.abs(innerHeight - window.innerHeight) > 100) ? innerHeight = window.innerHeight : innerHeight;
    }

    function onScroll(listener: () => void) {
        window.addEventListener('scroll', listener, { passive: true });
        requestAnimationFrame(listener);
    }
}